import ApiClient from './ApiClient';

class PartnersAPI extends ApiClient {
  constructor() {
    super('partners', { accountScoped: true });
  }
}

export default new PartnersAPI();
